import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { CoalService } from 'app/services/coal.service';
import { MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { AppState } from 'app/store/app.states';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-dialog-new-observation',
  templateUrl: './dialog-new-observation.component.html',
  styleUrls: ['./dialog-new-observation.component.scss']
})
export class DialogNewObservationComponent {
  formObservations: FormGroup;
  modificarDatos: boolean = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogNewObservationComponent>,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private coalService: CoalService,
    private store: Store<AppState>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formObservations = this.fb.group({
      nombre: new FormControl('', [Validators.required, Validators.maxLength(250)]),
      observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
      default: new FormControl(false)
    });

    if(data && data.attributes) {
      this.modificarDatos = true;
      this.formObservations.controls.nombre.setValue(data.attributes.nombre);
      this.formObservations.controls.observacion.setValue(data.attributes.observacion);
      this.formObservations.controls.default.setValue(data.attributes.default);
    }
  }

  addObservation () {
    this.formObservations.markAllAsTouched();
    this.formObservations.updateValueAndValidity();

    if(!this.formObservations.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000}
      )
    }
    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea guardar este registro?'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result) {
        let params = {
          data: {
            nombre: this.formObservations.value.nombre,
            observacion: this.formObservations.value.observacion,
            default: this.formObservations.value.default,
            ope_empresa: this.data.idEmpresa
          }
        }
        this.store.dispatch(MostrarSpinner());

        this.coalService.postService('ope-empresa-observaciones', params)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this.close(1);
        }, (error: any) => {
          this.store.dispatch(OcultarSpinner());
        })
      }
    });
  }

  modifyObservation () {
    this.formObservations.markAllAsTouched();
    this.formObservations.updateValueAndValidity();

    if(!this.formObservations.valid) {
      return this._snackBar.open(
        'Favor de completar los datos',
        'OK',
        { duration: 3000 }
      )
    }
    
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      data: '¿Desea modificar este registro?'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if(result) {
        let params = {
          data: {
            nombre: this.formObservations.value.nombre,
            observacion: this.formObservations.value.observacion,
            default: this.formObservations.value.default,
            ope_empresa: this.data.idEmpresa
          }
        }
        this.store.dispatch(MostrarSpinner());

        this.coalService.putService(`ope-empresa-observaciones/${this.data.id}`, params)
        .subscribe((res: any) => {
          this.store.dispatch(OcultarSpinner());
          this.close(1);
        }, (error: any) => {
          this.store.dispatch(OcultarSpinner());
        })
      }
    });
  }

  close(status) {
    this.dialogRef.close({
      success: status
    });
  }
}
